__turbopack_context__.v({
  "labels": "Progress-module__OOqJdW__labels",
  "labelsMax": "Progress-module__OOqJdW__labelsMax",
  "labelsValue": "Progress-module__OOqJdW__labelsValue",
  "pendingValue": "Progress-module__OOqJdW__pendingValue",
  "progressBar": "Progress-module__OOqJdW__progressBar",
  "range": "Progress-module__OOqJdW__range",
  "rangeLabel": "Progress-module__OOqJdW__rangeLabel",
  "rangeLine": "Progress-module__OOqJdW__rangeLine",
  "rangeThumb": "Progress-module__OOqJdW__rangeThumb",
  "rangeThumbEnd": "Progress-module__OOqJdW__rangeThumbEnd",
  "rangeThumbStart": "Progress-module__OOqJdW__rangeThumbStart",
  "root": "Progress-module__OOqJdW__root",
  "value": "Progress-module__OOqJdW__value",
});
